/**
 *  Module for pricing and availability.
 */

const Availability = function(app) {
  const asia = require('./locales/asia')(app);
  const us_eu = require('./locales/us_eu')(app);

  return {
    asia,
    us_eu
  };
};

module.exports = Availability;
